import React from "react";
import PropTypes from "prop-types";

import isRouteMatch from "shared/util/isRouteMatch";
import { ROUTES, ROUTE_LIST } from "routers/shared/util/consts";
import FooterAppCTA from "shared/components/FooterAppCTA";
import FooterContent from "shared/components/Footer";

// Routes to hide the footer on.
export const NO_FOOTER_ROUTES = [
	...ROUTES.AccountReactivate,
	...ROUTES.GDPR,
	...ROUTES.LegalPurchaseTerms,
	...ROUTES.Offboarding,
	...ROUTES.Onboarding,
	...ROUTES.PasswordReboarding,
	...ROUTES.PhoneWall,
	...ROUTES.RealName,
	...ROUTES.Signup,
	...ROUTES.Splash,
	...ROUTES.StandaloneConversation,
];

export const NO_CTA_ROUTES = [
	...ROUTES.Upgrade,
	...ROUTES.Incognito,
	...ROUTES.LostPassword,
];

const Footer = ({ location }) => {
	const is404 = !isRouteMatch(location, ROUTE_LIST);
	const showFooter = !is404 && !isRouteMatch(location, NO_FOOTER_ROUTES);
	const showCTA = !is404 && !isRouteMatch(location, NO_CTA_ROUTES);

	if (!showFooter) {
		return null;
	}

	return (
		<>
			{showCTA && <FooterAppCTA />}
			<FooterContent />
		</>
	);
};

Footer.propTypes = {
	location: PropTypes.object.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/routers/Desktop/Footer.jsx